import TemplateCreateDocumentPayStub from './TemplateCreateDocumentPayStub'

export default TemplateCreateDocumentPayStub
